import { styled, Typography } from '@mui/material';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import { type FC } from 'react';
import { useToggle } from '../../../../../../../../hooks/use-toggle';
import { ControlledTextInput } from '../../../../components/ControlledTextInput';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  StripeConfigurationControl,
  StripeConfigurationFormValues,
} from '../../StripeConfigurationFormSchema';

interface Props {
  defaultValues: StripeConfigurationFormValues;
  control: StripeConfigurationControl;
}

export const KeyConfigurationSection: FC<Props> = ({ control, defaultValues }) => {
  const [disabled, toggleDisabled] = useToggle(true);

  return (
    <ConfigurationSection title="Stripe Key" iconName="Key">
      <TextInputContainer {...getSelectorAttribute(integrationsPageSelectors.drawer.stripe.apiTokenInput)}>
        <TextInputHeaderContainer>
          <Typography
            sx={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            API Key
          </Typography>
          <Typography
            sx={{
              color: '#3A78F8',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              cursor: 'pointer',
            }}
            onClick={() => toggleDisabled()}
            {...getSelectorAttribute(integrationsPageSelectors.drawer.stripe.configuration.modifyKeyButton)}
          >
            Modify
          </Typography>
        </TextInputHeaderContainer>
        <ControlledTextInput
          name="apiToken"
          control={control}
          disabled={disabled}
          placeholder="Enter API Key here..."
          defaultValue={defaultValues.apiToken}
        />
      </TextInputContainer>
    </ConfigurationSection>
  );
};

const TextInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const TextInputHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});
